import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { NgxBootstrapModule } from './../libs/ngx-bootstrap/ngx-bootstrap.module';

import * as comps from './components';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';


@NgModule({
  declarations: [
    comps.ScrollbarComponent,
    comps.InputDatetimeControlComponent,
    comps.InputDatetimeRangeControlComponent,
    comps.InputEmailControlComponent,
    comps.InputNumberControlComponent,
    comps.InputPasswordControlComponent,
    comps.InputTextControlComponent,
    comps.InputTextMultilineControlComponent,
    comps.InputUrlControlComponent,
    comps.LabelControlComponent,
    comps.ModalComponent,
    comps.ModalContainerComponent,
    comps.SelectControlComponent,
    comps.SidebarComponent,
    comps.InputCheckboxControlComponent,
    comps.ButtonControlComponent,
    comps.GridControlComponent,
    comps.GridToolsComponent,
    comps.GridPagination,
    comps.UploadComponent,
    comps.ShowErrorComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    PerfectScrollbarModule,
    NgxBootstrapModule,
    ToastrModule.forRoot()
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    
    comps.ScrollbarComponent,
    comps.InputDatetimeControlComponent,
    comps.InputDatetimeRangeControlComponent,
    comps.InputEmailControlComponent,
    comps.InputNumberControlComponent,
    comps.InputPasswordControlComponent,
    comps.InputTextControlComponent,
    comps.InputTextMultilineControlComponent,
    comps.InputUrlControlComponent,
    comps.LabelControlComponent,
    comps.ModalComponent,
    comps.ModalContainerComponent,
    comps.SelectControlComponent,
    comps.SidebarComponent,
    comps.InputCheckboxControlComponent,
    comps.ButtonControlComponent,
    comps.GridControlComponent,
    comps.GridToolsComponent,
    comps.GridPagination,
    comps.UploadComponent,
    comps.ShowErrorComponent
  ],
  providers: []
})
export class MvcModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: MvcModule,
      providers: [  ]
    }
  }
}
